import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { VideoModelEntry } from '../types';

// 价格表: 美元/秒
const LTX25 = { '720p': 0.10, '1080p': 0.14, '2k': 0.21, '4k': 0.33 };
// 查找价格函数
const lookup = (table: Record<string, number>, quality?: string) =>
    table[quality?.toLowerCase() ?? ''] ?? Math.max(...Object.values(table));

const COST_FACTOR = 1.5;

export const ltxModels: VideoModelEntry[] = [
    {
        id: 'ltx-2.5',
        chef: providers['flowmuse'],
        providers: [
            {
                ...providers.flowmuse,
                model: wavespeed('ltx-2.5'),
                getCost: ({ duration, quality }) => {
                    const billedDur = duration ?? 5;
                    return billedDur * lookup(LTX25, quality) * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    const billedDur = duration ?? 5;
                    return billedDur * lookup(LTX25, quality) * COST_FACTOR * 100;
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['16:9', '9:16'],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p', '2k', '4k'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: [],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p', '2k', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: [],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p', '2k', '4k'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '10MB', formats: ['image/png', 'image/jpeg'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'first_last'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];